<template>
  <div>
    <PageTitle :route="$route">
      <template slot="action-button">
        <ActionButton
          icon="fa-plus"
          @click="onClickButton"
        />
      </template>
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <ReportActiveMovement />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ActionButton from '@/components/button/ActionButton'
import ReportActiveMovement from '@/components/reports/activemovement/ActiveMovement'

export default {
  name: 'ReportActiveMovementView',
  components: {
    PageTitle,
    ActionButton,
    PageRowWrapper,
    ReportActiveMovement
  },
  methods: {
    onClickButton (e) {
      this.$router.push({ name: 'addactivemovement' })
    }
  }
}
</script>